import React from 'react'
import { useSelector } from 'hooks/use-redux'
import type { Track } from 'types/track'
import { getShortlistTempItemForPreview } from '@disco/state-management/selectors/shortlists'
import TrackItem from 'components/common/track-item'
type Props = {
  track: Track
}

/**
 * Track drag preview component that displays track information during drag
 * Handles both regular tracks and temporary shortlist items with fallback logic
 * @param track - Track object to display in the drag preview
 */
const TrackDragPreview = ({ track }: Props): React.ReactNode => {
  const tempItem = useSelector(state =>
    getShortlistTempItemForPreview(state, {
      tempItemId: track.tempId || track.uploadId,
    }),
  )
  return (
    <TrackItem
      className="pane-item--inset"
      location="explorer"
      // @ts-expect-error
      track={tempItem || track}
    />
  )
}

export default TrackDragPreview
